import { useEffect, useState } from 'react';

import services from 'services';

const useSessionExpired = () => {
  const [isSessionExpired, setSessionExpired] = useState<boolean>(services.appFrame.auth.isSessionExpired);
  useEffect(() => {
    return services.appFrame.auth.onSessionExpired((sessionIsExpired: boolean) => {
      setSessionExpired(sessionIsExpired);
    });
  }, []);

  return isSessionExpired;
};

export default useSessionExpired;
